import axios from "axios";
import { setAccessToken } from "../store/slices/auth/slice";

// export const BASE_URL = "http://localhost:5000";
export const BASE_URL = "https://api.playbox.vip";

const API_BASE_URL = `${BASE_URL}/api`;
const AUTH_BASE_URL = `${BASE_URL}/auth`;

let store;
export const injectStore = (_store) => {
  store = _store;
};

const axiosAuthClient = axios.create({
  baseURL: AUTH_BASE_URL,
});

const axiosApiPublicClient = axios.create({
  baseURL: `${BASE_URL}/`,
});

const axiosApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

axiosAuthClient.interceptors.request.use(
  (config) => {
    config.headers = {};
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosApiPublicClient.interceptors.request.use(
  async (config) => {
    config.headers["X-MY-CSRF-PROTECTION"] = 5;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosApiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().authInfo.token;
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      // CHECK: this isn't necessary
      originalRequest._retry = true;

      try {
        const refreshResponse = await axiosAuthClient.get("/refresh-token", {
          withCredentials: true,
        });
        const { accessToken } = refreshResponse.data.data;
        store.dispatch(setAccessToken({ accessToken }));
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } catch (error) {
        // store.dispatch({ type: LOGOUT });
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosApiClient;
export { axiosAuthClient, axiosApiClient, axiosApiPublicClient };
